import { type FunctionComponent } from 'react';

import {
  DesktopLayoutDefault,
  DesktopLayoutDefaultContent,
} from '@kanda-libs/ks-design-library';

import JobTable from 'components/job/JobTable';
import { URLS } from 'components/shared/App/constants';
import PageTitle from 'components/shared/PageTitle';
import PresetFilter, {
  PresetFilterOption,
} from 'components/shared/PresetFilter';

import useJobListPage from './useJobListPage';

export interface JobsListPageProps { }

const JobsListPage: FunctionComponent<JobsListPageProps> = () => {
  const jobList = useJobListPage();
  const currentPath = window.location.href
    .split(window.location.host)[1]
    .split('?')[0];

  const options: PresetFilterOption[] = [
    { value: URLS.jobs, text: 'Applied+' },
    { value: URLS.jobsOngoing, text: 'Ongoing' },
    { value: URLS.jobsSatNote, text: 'SatNote Sent / Viewed' },
    { value: URLS.jobsSatNoteSigned, text: 'SatNote Signed' },
    { value: URLS.jobsSatNoteDelayed, text: 'SatNote Delayed' },
    { value: URLS.jobsSatNoteLenderReview, text: 'SatNote Lender Review' },
    { value: URLS.jobsPayoutPending, text: 'Payout Pending' },
    { value: URLS.jobsPaid, text: 'Paid' },
    { value: URLS.jobsAll, text: 'All' },
  ];

  return (
    <DesktopLayoutDefault>
      <DesktopLayoutDefaultContent>
        <PageTitle>Jobs</PageTitle>
        <PresetFilter
          menuItem="jobs"
          currentPath={currentPath}
          options={options}
        />
        <JobTable {...jobList} />
      </DesktopLayoutDefaultContent>
    </DesktopLayoutDefault>
  );
};

export default JobsListPage;
